import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { USER_ROLE } from "../../../enums";
import { wallets } from "../../../pages/wallets/constants";
import { ROUTES } from "../../../setup/constants";
// styles
import styles from "../styles.module.scss";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const ReleaseToSeller = (props: any) => {
  const { type, transactionsInfo } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onContractClick = (contractId: string) => {
    navigate(`${ROUTES.CONTRACT}${contractId}`);
  };

  const amountSection = () => (
    <div className={styles["amount_container"]}>
      <h3 className={classNames("primary", "ml2")}>
        {transactionsInfo.amount}
      </h3>
      <p className={"hint"}>{t("lbl_saudi_currency")}</p>
    </div>
  );

  return (
    <div className={styles["container"]}>
      {amountSection()}
      <div className={styles["details_section"]}>
        <div className={styles["details_section__top"]}>
          {type === USER_ROLE.BUYER ? (
            <h4>
              {wallets.PAYMENT_CUSTOMER_REFUND +
                " " +
                transactionsInfo.amount +
                wallets.PAYMENT_CUSTOMER_REFUND_TEXT}
              <span
                onClick={() => {
                  onContractClick(transactionsInfo.contractId);
                }}
                className={"primary"}>
                #{transactionsInfo.shortContractId}
              </span>
              {wallets.PAYMENT_CUSTOMER_REFUND_TEXT_ACCOUNT}
              {transactionsInfo.beneficiaryName}
            </h4>
          ) : (
            <h4>
              {wallets.SELLER_PAYMENT_CUSTOMER_REFUND +
                " " +
                transactionsInfo.amount +
                wallets.SELLER_PAYMENT_CUSTOMER_REFUND_TEXT}
              <span
                className={"primary"}
                onClick={() => {
                  onContractClick(transactionsInfo.contractId);
                }}>
                #{transactionsInfo.shortContractId}
              </span>
              {wallets.SELLER_PAYMENT_CUSTOMER_REFUND_TEXT_ACCOUNT}
            </h4>
          )}
        </div>
        <p className={"p2"}>{t("lbl_bank_description")}</p>
      </div>
    </div>
  );
};
export default ReleaseToSeller;
